module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: 'ql-' + _vm.type,
    attrs: {
      "type": "button"
    }
  })
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-72809dbd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/TextEditor/toolbar/Button.vue
 ** module id = 856
 ** module chunks = 1
 **/